module.exports = __webpack_public_path__ + "img/icon_mascot.e51316aa.svg";